// Hover on display for each menu
document.addEventListener("DOMContentLoaded", function () {
  // Select all top-level nav items that have a data-division-title attribute.

  // Select divisions, division links & subdivisions
  const divisions = document.querySelectorAll(
    ".nav-bar__linklist > .division-item"
  );
  const divisionLinks = document.querySelectorAll(
    ".nav-bar__linklist > .division-item a[data-division-title]"
  );
  const subDivisions = document.querySelectorAll(
    ".nav-bar__inner.sub-division"
  );

  // Loop over each nav item.
  divisionLinks.forEach((divisionLink, index) => {
    divisionLink.addEventListener("mouseenter", function () {
      divisions.forEach((division) =>
        division.classList.remove("active-division")
      );

      // Add the active class to the hovered nav item's parent li.
      if (divisionLink.parentElement) {
        divisionLink.parentElement.classList.add("active-division");
      }

      // Remove the active class from all submenus & add the active class to the corresponding submenu through data property connected-vision
      const divisionTitle = divisionLink.dataset.divisionTitle;
      subDivisions.forEach((sub) => {
        const subConnectedDivision = sub.dataset.connectedDivision;
        sub.classList.remove("active-division");
        if (subConnectedDivision === divisionTitle) {
          sub.classList.add("active-division");
        }
      });
    });
  });
});

function updateCartAttributeAndRedirect(divisionValue, targetUrl) {
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: {
        division: divisionValue,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      // Example: Force fresh load with division param
      window.location.href =
        targetUrl + "?division=" + encodeURIComponent(divisionValue);
    })
    .catch((error) => {
      console.error(error);
    });
}

// Division links
const divisionLinks = document.querySelectorAll(".divisions .nav-bar__link");
divisionLinks.forEach((link) => {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    const divisionValue = link.getAttribute("data-division-title");
    const targetUrl = link.getAttribute("href") || "#";
    updateCartAttributeAndRedirect(divisionValue, targetUrl);
  });
});

// Header logo
const headerLogo = document.querySelector("img.header__logo-image");
headerLogo.addEventListener("click", function (e) {
  e.preventDefault();
  // Redirect to home (example) and clear the attribute
  updateCartAttributeAndRedirect("none", window.Shopify.routes.root);
});
